export const HOLDINGS_LAYER_HOLDINGS = 'direct_holdings';
export const HOLDINGS_LAYER_INVESTED_HOLDINGS = 'invested_holdings';
export const HOLDINGS_LAYER_UNDERLYING_HOLDINGS = 'underlying_holdings';
export const HOLDINGS_LAYER_DROPDOWN_CONFIG = {
    list: [
        {
            disabled: false,
            label: 'Holdings',
            type: 'option',
            value: HOLDINGS_LAYER_HOLDINGS,
        },
        {
            disabled: false,
            label: 'Invested Holdings',
            type: 'option',
            value: HOLDINGS_LAYER_INVESTED_HOLDINGS,
        },
        {
            disabled: false,
            label: 'Underlying Holdings',
            type: 'option',
            value: HOLDINGS_LAYER_UNDERLYING_HOLDINGS,
        },
    ],
};
